
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.75 22.5A3.747 3.747 0 013.752 21H3.75A3.754 3.754 0 010 17.25V6.75A3.754 3.754 0 013.75 3h.002A3.747 3.747 0 016.75 1.5h1.5c1.183 0 2.289.557 2.998 1.5h9.001a3.754 3.754 0 013.75 3.75v10.5a3.754 3.754 0 01-3.75 3.75h-9.001a3.744 3.744 0 01-2.998 1.5h-1.5zm0-19.5A2.252 2.252 0 004.5 5.25v13.5A2.252 2.252 0 006.75 21h1.5a2.252 2.252 0 002.25-2.25V5.25C10.5 4.009 9.49 3 8.25 3h-1.5zm13.499 16.5a2.252 2.252 0 002.25-2.25V6.75a2.252 2.252 0 00-2.25-2.25h-8.327c.052.248.078.499.078.75v13.5c0 .251-.026.502-.078.75h8.327zM3.056 4.613A2.254 2.254 0 001.5 6.75v10.5c0 .989.651 1.843 1.556 2.137A3.687 3.687 0 013 18.75V5.25c0-.213.019-.426.056-.637z"}}),_c('path',{attrs:{"d":"M15 7.5A.75.75 0 0115 6h4.5a.75.75 0 010 1.5H15zM19.125 12.75a1.123 1.123 0 01-.058-2.246l.058-.004c.62 0 1.125.505 1.125 1.125s-.505 1.125-1.125 1.125zM19.125 16.5c-.62 0-1.125-.505-1.125-1.125a1.127 1.127 0 011.174-1.122h.004a1.12 1.12 0 011.073 1.122 1.128 1.128 0 01-1.126 1.125z"}}),_c('circle',{attrs:{"cx":"15.375","cy":"11.625","r":"1.125"}}),_c('path',{attrs:{"d":"M15.375 16.5c-.62 0-1.125-.505-1.125-1.125 0-.599.468-1.09 1.068-1.121a.587.587 0 01.057-.004c.62 0 1.125.505 1.125 1.125s-.505 1.125-1.125 1.125z"}})])
          )
        }
      }
    